import { FormLabel, FormLabelProps } from '@chakra-ui/react'

export type { FormLabelProps }

export default FormLabel
